import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  try {
    config.headers['X-Client-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['X-Client-Timezone-Offset'] = String(new Date().getTimezoneOffset());
  } catch {
  }

  return config;
});

export const logout = () => {
  localStorage.removeItem('token');
  // You can add additional cleanup here if needed
  // For example, clearing other stored data
  window.location.href = '/login';
};

export default api;
